import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=3f194a19&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f194a19')) {
      api.createRecord('3f194a19', component.options)
    } else {
      api.reload('3f194a19', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=3f194a19&", function () {
      api.rerender('3f194a19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/complaintManage/returnVisitQuery/detail.vue"
export default component.exports